import React, { Component } from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  HeaderFilter,
  FilterRow,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarTipoUsoLogradouroPublicoDs } from "../DataSources";
import uiInfo from "../ui-info";
import UserInfo from "../UserInfo";

export default class TipoUsoLogradouroBox extends Component {
  constructor() {
    super();
    this.initNewRow = this.initNewRow.bind(this);
    this.dataSource = criarTipoUsoLogradouroPublicoDs();
    this.moedas = [
      { id: 0, descricao: "Real" },
      { id: 1, descricao: "Unidade Fiscal" }
    ]
  }

  render() {
    console.log("Render bairro");
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar titulo="TIPO DE USO DO LOGRADOURO">
            <DataGrid
              dataSource={this.dataSource}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              focusedRowEnabled={true}
              onInitNewRow={this.initNewRow}
            >
              <Editing
                mode={"row"}
                allowAdding={false}
                allowUpdating={true}
                allowDeleting={true}
                useIcons={true}
              />
              <Column
                dataField={"sequencial"}
                caption={"#"}
                width={"150"}
                alignment={"center"}
                allowEditing={false}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"descricao"} caption={"Descrição"} />
              <Column dataField={"tipoMoeda"} caption={"Moeda"}>
                <Lookup dataSource={this.moedas} displayExpr={"descricao"} valueExpr={"id"} />
              </Column>
              <Column dataField={"valorPorDia"}
                caption={"Valor por dia (R$)"}
                dataType="number"
                format={uiInfo.formatoNumerico.n2}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }} />
              <Column dataField={"valorPorMes"}
                caption={"Valor por Mês (R$)"}
                dataType="number"
                format={uiInfo.formatoNumerico.n2}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }} />
              <Column dataField={"valorPorAno"}
                caption={"Valor por Ano (R$)"}
                dataType="number"
                format={uiInfo.formatoNumerico.n2}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }} />
              <Column
                dataField={"cobrancaPorM2"}
                caption={"Cobrança por m²"}
                editorType={"dxCheckBox"}
                alignment={"center"}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={uiInfo.tamanhoPaginaOpcoes}
                allowedPageSizes={uiInfo.tamanhoPaginaPadrao}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
    e.data.cobrancaPorM2 = false;
    e.data.tipoMoeda = 0;
  }
}
